import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

export interface InfoResponse {
    app_name: string,
    version: string,
    env: string,
    imapStatus: string,
    ipV4: any,
    networkInterfaces: any,
    buildDate?: string
}

async function getInfo(): Promise<InfoResponse> {
    try {
        return await HttpClient.get('/info');
    } catch (e) {
        console.log('error: ', e);
        throw new GetInfoFailure();
    }
}

export class GetInfoFailure extends Failure {
    constructor(message = 'Unknown error', code = 'unknown-error') {
        super(message, code);
    }
}

export default getInfo;
